import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import { StyledIssuesList } from './IssuesList/IssuesList.style';
import { StyledInvestmentBreakdown } from './InvestmentBreakdown/InvestmentBreakdown.style';

export const StyledColorIndicator = styled.div`
  background-color: ${props => props.color};
  width: 1rem;
  height: 1rem;
  border-radius: 0.1rem;
`;

export const StyledTooltipTitle = styled.div`
  display: flex;
  align-items: center;
  & > .primary {
    font-weight: bold;
    margin-right: 1rem;
  }
  font-size: 1.3rem;
`;

export const StyledTooltipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > .stats {
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    & > .primary {
      font-size: 1.4rem;
      font-weight: bold;
      margin-left: 0.5rem;
      margin-right: 0.3rem;
    }
    & > .secondary {
      font-size: 1.2rem;
      color: ${getColor('shuttleGray')};
    }
  }
`;

export const StyledTooltipMain = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledTooltip = styled.div`
  min-width: 45rem;
  max-width: auto;
  overflow: hidden;
  box-sizing: border-box;
  height: 30rem;

  &.shouldShowInvestmentBreakdown,
  &.shouldShowIssuesList {
    min-width: 50rem;
  }
  &.isOthersCategory {
    height: auto;
  }
  padding: 1rem;
  & ${StyledTooltipTitle} {
    height: 10%;
  }
  & ${StyledTooltipHeader} {
    height: 20%;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  & ${StyledTooltipMain} {
    width: 100%;
    height: 56%;
    font-size: 1.2rem;
    & ${StyledInvestmentBreakdown}, & ${StyledIssuesList} {
      margin-right: 1rem;
      overflow: hidden;
    }
  }
  & ${StyledColorIndicator} {
    margin-left: auto;
  }
`;
